import React from 'react';

const UserProduct = ({ product }) => {
  return (
    <div className="product-card">
      <img src={product.image_url} alt={product.name} />
      <h3>{product.name}</h3>
      <p>{product.description}</p>
      <p>Price: ${product.price}</p>
      <button>Add to Cart</button>
      {/* You can add more details or functionality like view more, add to wishlist, etc. */}
    </div>
  );
};

export default UserProduct;
